<template>
  <div class="job-item-container">
    <div class="job-basic-info">
      <el-tooltip
        effect="light"
        popper-class="light-tooltip-popper"
        :content="jobTitle"
      >
        <span class="job-title" @click="handelToApplication">{{ jobTitle }}</span>
      </el-tooltip>
      <div class="basic-info">
        <span class="id">ID{{ jobObj.id }}</span>
        <el-tooltip
          effect="light"
          popper-class="light-tooltip-popper"
          :content="jobObj.creator.name"
        >
          <span class="creator">{{ jobObj.creator.name }}</span>
        </el-tooltip>
        <span class="open-date">{{ openDate }}</span>
      </div>
      <el-tooltip
        effect="light"
        popper-class="light-tooltip-popper"
        :content="jobLocation"
      >
        <span class="job-location">{{ jobLocation }}</span>
      </el-tooltip>
      <div class="operate-container">
        <el-button v-if="!isJobClosed" type="primary" class="btn add-button" @click="handleAddCandidate" plain>{{ $t(`${i18nPrefix}.label.addCandidate`) }}</el-button>
        <el-button type="primary" class="btn share-button" @click="handelShare" plain>{{ $t(`${i18nPrefix}.label.generateJobShare`) }}</el-button>
        <el-button v-if="!isJobClosed" type="primary" class="btn view-button" @click="openJobDetail" plain>{{ $t(`${i18nPrefix}.label.openJobDetail`) }}</el-button>
      </div>
    </div>
    <div class="applicant_count_container">
      <div class="count-container total">
        <span class="number" @click="handelToApplication">
          {{ jobObj.applicant_info.total_num | formatBigNumber }}
        </span>
        <span class="label">{{ $t(`${i18nPrefix}.label.total`) }}</span>
      </div>
      <div class="count-container open-days">
        <span class="number">{{ jobObj.open_days | formatBigNumber }}</span>
        <span class="label">{{ $t(`${i18nPrefix}.label.openDays`) }}</span>
      </div>
    </div>
    <DialogWrapper
      class="channel-dialog"
      :show.sync="shareDialog.show"
      :close-on-click-modal="false"
      :hideFooter="true"
    >
      <ShareDialog v-if="shareDialog.show" :jobId="jobObj.id" :jobName="jobTitle" :isJobShare="true" :shareUrl="shareUrl" :hiddenSourceCode="true" :hiddenTitleTip="true" @close="handelCloseShareDialog"/>
    </DialogWrapper>
    <ConfirmDialog
      v-if="confirmDialog.show"
      :content="confirmDialog.content"
      :show.sync="confirmDialog.show"
      :title="confirmDialog.title"
      :loading="confirmDialog.loading"
      @confirm="confirmDialog.confirmMethod"
      @cancel="confirmDialog.cancelMethod"
    />
    <RectLoading class="loading" v-show="loading"/>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { formatBigNumber } from '@/components/filters'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import ConfirmDialog from '@/components/dialog/confirmDialog.vue'
import ShareDialog from '../../../adminNew/jobList/components/shareJobDialog.vue'
import RectLoading from '@/components/loading/rectLoading'
import { JOB_POSTING_STATUS, OPERATION_TYPE } from '@/constant/company'

const DEFAULT_CHANNEL_ID = 1

export default {
  components: {
    DialogWrapper,
    ShareDialog,
    ConfirmDialog,
    RectLoading
  },
  props: {
    jobObj: {
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.list',
      formatBigNumber,
      loading: false,
      channelDialog: {
        show: false,
        needRefresh: false
      },
      shareDialog: {
        show: false
      },
      agencyDialog: {
        show: false
      },
      confirmDialog: {
        show: false,
        title: '',
        content: '',
        confirmMethod: null,
        cancelMethod: null,
        loading: false
      },
      channelActionMapping: {
        ADD: 'add',
        DELETE: 'delete',
        UPDATE: 'update'
      }
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    jobTitle () {
      return this.isEn ? this.jobObj.name : this.jobObj.cn_name
    },
    isJobClosed () {
      return this.jobObj.status === '0' || this.jobObj.status === '2' || this.jobObj.status === '3'
    },
    openDate () {
      const publishDate = `${moment(this.jobObj.created_time).format('YYYY/MM/DD')}`
      const expireDate = `${moment(this.jobObj.expire_date).format('YYYY/MM/DD')}`
      return `${publishDate}-${expireDate}`
    },
    jobLocation () {
      return this.jobObj.city_list.join('/')
    },
    applicantCountGroup () {
      const groupList = ['SCREEN', 'INTERVIEW', 'OFFER', 'HIRED']
      const result = []
      _.forEach(groupList, (group) => {
        const groupInfo = this.getStatusInfo(group)
        const newGroupInfo = {
          count: formatBigNumber(groupInfo.count),
          name: _.lowerCase(group),
          label: this.$t(`${this.i18nPrefix}.label.${_.lowerCase(group)}`),
          statusList: groupInfo.statusList
        }
        this.$set(newGroupInfo, 'expand', false)
        result.push(newGroupInfo)
      })
      return result
    },
    shareUrl () {
      return `${location.origin}/job-detail-new/${this.jobObj.id}/c/`
    },
    displayChannelList () {
      const list = []
      _.forEach(this.jobObj.job_posting_channels, (item) => {
        if (item.status === JOB_POSTING_STATUS.FINISHED) {
          if (item.operation_type !== OPERATION_TYPE.DELETE) {
            list.push({
              actionClass: 'publish',
              ...item
            })
          }
        } else {
          list.push({
            actionClass: this.channelActionMapping[item.operation_type],
            ...item
          })
        }
      })
      return list
    }
  },
  created () {
  },
  methods: {
    openJobDetail () {
      const path = `/job-detail-new/${this.jobObj.id}/c/`
      window.open(path)
    },
    handelShare () {
      this.shareDialog.show = true
    },
    handelCloseShareDialog () {
      this.shareDialog.show = false
    },
    handelToApplication () {
      const path = `/v-agency/job/${this.jobObj.id}/application`
      window.open(path)
    },
    generateChannelTips (channelInfo) {
      if (!channelInfo) {
        return ''
      }
      let channelName = this.isEn ? channelInfo.name : channelInfo.cn_name
      if (!channelName) {
        channelName = channelInfo.name || channelInfo.cn_name
      }
      if (channelInfo.id === DEFAULT_CHANNEL_ID) {
        channelName = this.isEn ? 'Career Site' : '职位主页'
      }

      let i18nName = 'channelReadyPost'
      if (channelInfo.status === '2') {
        i18nName = 'channelAlreadyAction'
      } else if (channelInfo.operation_type === OPERATION_TYPE.DELETE) {
        i18nName = 'channelReadyClose'
      } else if (channelInfo.operation_type === OPERATION_TYPE.UPDATE) {
        i18nName = 'channelReadyRefresh'
      }
      return this.$t(`${this.i18nPrefix}.message.${i18nName}`, { channelName })
    },
    getStatusInfo (status) {
      return _.find(this.jobObj.statusCountGroup, ['name', status])
    },
    handleAddCandidate () {
      this.$router.push({ path: `/v-agency/application/job/${this.jobObj.id}/add`, query: { back: this.$route.fullPath } })
    },
    handelCancelOption () {
      this.$message.info(this.$t(`${this.i18nPrefix}.message.cancelAction`))
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.job-item-container {
  padding: 18px 16px;
  background: #FFFFFF;
  box-shadow: 0px 2px 3px -1px rgba(0,0,0,0.08);
  border-radius: 3px;
  border: 1px solid #E4E7ED;
  display: flex;
  align-items: center;
  position: relative;

  .hot-icon {
    font-size: 16px;
    top: 24px;
    color: #C0C4CC;
    position: absolute;

    &.is-hot {
      color: #EE7815;
    }
  }

  .checkbox-container {
    position: relative;

    .mask {
      width: 100%;
      height: 100%;
      cursor: pointer;
      position: absolute;
      top: 0;
      z-index: 9;
    }
  }

  .job-basic-info {
    flex: 1;
    padding: 0 50px 0 20px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    span {
      white-space: nowrap;
      word-break: keep-all;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      flex-shrink: 0;
      color: #606266;
    }

    .job-title {
      font-size: 20px;
      line-height: 28px;
      height: 28px;
      font-weight: 500;
      color: #0096CC;
      position: relative;
      cursor: pointer;
    }

    .basic-info {
      margin: 6px 0;
      display: inline-flex;
      overflow: hidden;

      > span {
        line-height: 20px;
      }

      .creator {
        overflow: hidden;
        text-overflow: ellipsis;
        flex-shrink: 1;
        margin-left: 15px;
      }
      .open-date {
        margin-left: 15px;
      }
    }

    .job-location {
      line-height: 20px;
      height: 20px;
    }

    .operate-container {
      margin: 10px 0px 6px 0px;
      display: flex;
      align-items: center;

      .btn {
        padding: 4px 22px;
        font-size: 14px;
        border-radius: 2px;
        border-width: 2px;
        background: #FFFFFF;
        color: #0096CC;
        border-color: #0096CC;

        &:not(.disabled):hover {
          background: #0096CC;
          color: #FFF;
        }

        &.disabled {
          cursor: not-allowed;
        }
      }
    }
  }

  .status-switch {
    position: absolute;
    right: 16px;
    top: 18px;
    opacity: unset;

    &::v-deep {
      &.is-disabled {
        .el-switch__core {
          cursor: pointer;
        }
      }
    }
  }

  .applicant_count_container {
    display: flex;
    margin-top: 16px;
    justify-content: flex-end;

    .count-container {
      width: 81px;
      background: #FFFFFF;
      border: 1px solid #DCDFE6;
      display: flex;
      padding: 36px 0 24px 0;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .expand-button {
        cursor: pointer;
      }

      .number {
        font-size: 18px;
        line-height: 25px;
        height: 25px;
        font-weight: 400;
        color: #606266;
        cursor: pointer;

        &:hover {
          color: #0096CC;
        }
      }

      .label {
        font-size: 14px;
        color: #909399;
        font-weight: 400;
        line-height: 19px;
        height: 19px;
      }

      .un-read-container {
        color: #0096cc;
        font-size: 12px;
        line-height: 1;
        font-weight: bold;
        text-align: right;
        position: absolute;
        top: 6px;
        right: 6px;
        cursor: pointer;
      }

      .el-icon-caret-bottom {
        font-size: 14px;
        color: #909399;
      }

      .number-box {
        display: flex;
        align-items: center;
      }

      &.total {
        position: relative;
      }

      &.screen {
        border-right: 0;
      }

      &.offer {
        border-right: 0;
      }

      &.interview {
        border-right: 0;
      }

      &.leads {
        margin-left: 6px;
      }

      &.open-days {
        margin-left: 6px;
        .number {
          cursor: unset;

          &:hover {
            color: #606266;
          }
        }
      }
    }
  }

  .loading {
    position: absolute;
  }
}
</style>
